import NotificationsTabContent from '../NotificationsTabContent';

/**
 * Notifications Transactions
 */
const NotificationsTransactions = () => <NotificationsTabContent category="transactions" />;

export default NotificationsTransactions;
